<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-upload"
      scrollable
      centered
      title="NxGED - Importar Arquivos"
      size="xl"
      @hidden="onResetModal"
    >
      <table class="table table-hover">
        <thead class="thead-third" style="border: 1px solid rgb(2, 119, 189); height: 44px;">
          <tr>
            <th class="text-center"><span>#</span></th>
            <th class="text-center"><span>Nome</span></th>
            <th class="text-center"><span>Tamanho</span></th>
            <th class="text-center"><span>Problemas</span></th>
            <th class="text-center"><span>Ações</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, index) in importFiles" :key="index">
            <td class="text-center">
              <i class="fas fa-exclamation-triangle text-danger" v-if="file.size > limitSizeFiles"></i>
              <i class="fas fa-file text-third" v-else></i>
            </td>
            <td class="text-center">
              <strong :class="file.size > limitSizeFiles ? 'text-danger': ''">{{ file.name }}</strong>
            </td>
            <td class="text-center" :class="file.size > limitSizeFiles ? 'text-danger': ''">{{ bytesToSize(file.size) }}</td>
            <td class="text-center">
              <span :class="file.size > limitSizeFiles ? 'text-danger': ''" v-if="file.size > limitSizeFiles" title="Ultrapassou o tamanho máximo permitido para upload do arquivo">Tamanho máximo</span>
              <span v-else>&nbsp;</span>
            </td>
            <td class="text-center">
              <button type="button" class="btn btn-danger btn-sm" @click="onRemove(index)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <b-progress :value="progressBarValue" :max="100" show-progress animated variant="success"></b-progress>
      <div class="row mt-4 mb-4" v-if="false">
        <div class="col-12">
          <div class="text-center" style="background-color: #fff; border: dotted 1px #04a791; padding: 20px; border-radius: 5px;">
            <div class="pt-5"><i class="fas fa-upload text-third"></i></div>
            <div><strong>Clique para enviar um arquivo</strong> ou arraste e solte aqui</div>
            <div class="pb-5"><small>Tamanho máximo permitido: 30mb</small></div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="'Importar arquivos'" @click.prevent="onImport">
            <i class="fas fa-cloud-upload-alt"></i><span class="d-md-down-none"> Importar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'ModalUpload',
  mixins: [ActionsForm],
  data () {
    return {
      limitSizeFiles: 30000000,
      files: [],
      progressBarValue: 0
    }
  },
  computed: {
    importFiles () {
      return this.files
    }
  },
  methods: {
    showModal (files) {
      this.onClear()
      this.$refs['modal-upload'].show()
      this.progressBarValue = 0
      this.files = []
      this.files = files
    },
    hideModal () {
      this.$refs['modal-upload'].hide()
    },
    onResetModal () {
      this.files = []
      this.progressBarValue = 0
    },
    bytesToSize (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    onRemove (index) {
      this.files.splice(index, 1)
      if (this.files.length === 0) {
        this.hideModal()
      }
    },
    onImport () {
      this.uploadingFiles = this.files
      let waitFiles = 500 * this.uploadingFiles.length
      this.$emit('Import', this.uploadingFiles)
      for (let i = 0; i < 100; i++) {
        setTimeout(() => {
          this.progressBarValue = i
        }, waitFiles)
        if (i === 99) {
          this.progressBarValue = 100
          setTimeout(() => {
            this.files = []
            this.hideModal()
          }, 500)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/rightcontent/components/modalupload.vue